<template>
	<div>
		<div class="row">
			<div class="card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing">
				<div class="card-body col-12">
          <ul
            class="nav nav-tabs bg-white border-0 rounded-0"
            id="myTab"
            role="tablist"
          >
            <li v-for="(item, index) in overViewData.productList" :key="item.productName" class="nav-item" role="tablist">
              <button 
                :class="['nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100', { active: (index==selectedProductIndex)?true:false }]"
                role="button"
                :aria-selected="(index==selectedProductIndex)?true:false"
                @click="selectProduct(index)"
                >{{ item.text }}
              </button>
            </li>
          </ul>
        </div>
				<div class="row">
					<div class="col-12 col-md-6">
							<span class="col-12">
									<DateSelector @selectedDateChanged="handleSelectedDateChange"/>
								<span class="row">
									<div class="col-6">
										<label class="d-block text-black fw-semibold mb-10">Typ licence</label>
										<select
											v-model="licenseSelected"
											@change="getNewData()"
											class="form-select shadow-none fw-semibold rounded-0 col-6"
										>							
											<option v-for="option in getTypeLicense()"
												:key="option.value" 
												:value="option.value">
													{{option.text}}
											</option>
										</select>
									</div>
									<div class="col-6">
										<label class="d-block text-black fw-semibold mb-10">Typ účetnictví</label>
										<select
											v-model="uctSelected"
											@change="getNewData()"
											class="form-select shadow-none fw-semibold rounded-0 col-6"
										>
											<option v-for="option in getTypeUct()"
												:key="option.value" 
												:value="option.value">
													{{option.text}}
											</option>
										</select>
									</div>
									<div class="col-6">
										<label class="d-block text-black fw-semibold mb-10">Typ organizace</label>
										<select
											v-model="organizationSelected"
											@change="getNewData()"
											class="form-select shadow-none fw-semibold rounded-0 col-6"
										>
											<option v-for="option in getTypeOrg()"
												:key="option.value" 
												:value="option.value">
													{{option.text}}
											</option>
											<!--<option value="FULL" >FULL
											<option value="DEMO" >DEMO</option>
											<option value="TRIAL">TRIAL</option>-->
										</select>
									</div>
								</span>
							</span>  
							<span class="row justify-content-left p-3">
								<div
									class="card mb-25 ml-1 border-0 rounded-0 bg-white letter-spacing col-auto"
								>
									<div class="card-body shift-card-body">
										<div class=" align-items-center">
											<div class="">
												<div class="product-details-content">
													<ul class="info ps-0 list-unstyled d-inline-block">
														<li class="text-para fs-md-15 fs-xxxl-16">
															<!--<span class="text-black fw-semibold d-inline-block">Počet otevřených evidencí: </span>-->
															<!--<span class="overView-value">{{statisticsData.totalEvidenceCount}}</span>-->
														</li>
														<li class="text-paragraph fs-md-15 fs-xxxl-16">
															<!--<span class="text-black fw-semibold d-inline-block">Nejčastější unikátní evidence: </span>-->
																<a
																	@click="redirectToEvidence(statisticsData.mostFrequentUniqueEvidence, overViewData.productList[selectedProductIndex].value)"
																	class="d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
																	href="javascript:void(0);"  
																>
																<!--	{{capitalizeString(true, statisticsData.mostFrequentUniqueEvidence)}}-->
																</a>
														</li>
														<li class="text-paragraph fs-md-15 fs-xxxl-16">
															<!--<span class="text-black fw-semibold d-inline-block">Nejčastější unikátní evidence: </span>-->
																<a
																	@click="redirectToEvidence(statisticsData.mostFrequentEvidence, overViewData.productList[selectedProductIndex].value)"
																	class="d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
																	href="javascript:void(0);"  
																>
																<!--	{{capitalizeString(true, statisticsData.mostFrequentEvidence)}}-->
																</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									class="card mb-25 ml-1 border-0 rounded-0 bg-white letter-spacing col-auto"
								>
									<div class="card-body shift-card-body">
										<div class=" align-items-center">
										</div>
									</div>
								</div>
							</span>
						</div>
						<div class="col-sm-6 col-12 maximum-graph-size">
							<DocumentInfoPieGraph :graphData="documentInfoOverviewList" :borderDates="borderDates"/>
						</div>
				</div>
			</div>
		</div>
		<div v-if="tableOptions != undefined">
			<DataTable :tableData="tableData" :tableOptions="tableOptions" @tableRestrictionChange="getNewData" ref="tableDataRef"/>
		</div>
	</div>
</template>

<script lang="ts">

	//Library imports
	import axios from 'axios';

	//Component imports
	import DateSelector from '@/components/Common/DateSelector.vue';
	import DocumentInfoPieGraph from '../DocumentInfo/DocumentInfoPieGraph.vue';
	import DataTable from "../../Common/SortableTable.vue"

	//Function imports
	import {defineComponent, toRefs, ref, onMounted} from 'vue';

	//Shared values
	import { getTypeOrg, getTypeUct, getTypeLicense} from "../../../utils/shared";

	export default defineComponent({
		props:["overViewData"],
		name: "documentInfoOverview",
		components: {
			DateSelector,
			DataTable,
			DocumentInfoPieGraph
		},
		setup(props){
			let { overViewData } = toRefs(props);
			let selectedProductIndex = ref(0);

			let documentInfoOverviewList = ref<any>([]);

			//Table relared data
			let tableOptions = ref({});
			let tableDataRef = ref<any>(null);
			let tableData = ref<any>({});
			let statisticsData = ref({});

			//Time related variables
			let borderDates = ref<{ startDate: any, endDate: any }>({ startDate: new Date().toISOString().split("T")[0], endDate: new Date().toISOString().split("T")[0] });
			let timeSelected = ref();

			//Selection varibales
			let licenseSelected = ref("FULL");
			let organizationSelected = ref("1");
			let uctSelected = ref("1");

			onMounted(() => {
				prepareTableData();
			})

			const prepareTableData = () =>{
				let headers = [{text: "Doklad", key: "evidence", capitalizedString: true},{text: "Aktuální počet záznamů", key: "usageCount"},{text: "Počet instalací", key: "uniqueUsageCount"},{text: "Počet firem", key: "company_count"},{text: "Seznam instalaci", key: "installationList"}];
				let defaultOrder = {orderBy: "uniqueUsageCount", orderDirection: "ASC"};
				let modalSelection = [{key: "installationList", redirectToName: "Installation-detail", paramName: "appuuid"}]
				tableOptions.value["headers"] = headers;
				tableOptions.value["redirects"] = [];
				tableOptions.value["defaultOrder"] = defaultOrder;
				tableOptions.value["modalSelection"] = modalSelection;
			}

			const selectProduct = (index) =>{
				for(let key in overViewData.value.productList){
					if(key == index){
						selectedProductIndex.value = index;
					}
				}
				getDocumentInfoData(timeSelected.value, overViewData.value.productList[selectedProductIndex.value].value, licenseSelected.value, organizationSelected.value, uctSelected.value)
			}

			const handleSelectedDateChange = (newBorderDates, newTimeSelected) =>{
				borderDates.value = newBorderDates;
				timeSelected.value = newTimeSelected;
				getDocumentInfoData(timeSelected.value, overViewData.value.productList[selectedProductIndex.value].value, licenseSelected.value, organizationSelected.value, uctSelected.value)
			}

			const getNewData = () =>{
				getDocumentInfoData(timeSelected.value, overViewData.value.productList[selectedProductIndex.value].value, licenseSelected.value, organizationSelected.value, uctSelected.value);
			}

			const getDocumentInfoData = (dateRangeName: string, productName: string, licenseSelected: string, organizationSelected: string, uctSelected: string) => { 
				const tableRestrictions = tableDataRef.value.tableRestrictions();
				const filterData = (tableRestrictions.filterData == undefined)?[]:tableRestrictions.filterData;
				const selectionFilter = {
					license: licenseSelected,
					typOrg: organizationSelected,
					typUct: uctSelected
				}
				tableRestrictions.filterData = filterData;
				//documentInfoOverviewList.value = [ { "evidence": "ZAV1N", "usageCount": 22, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "POH1", "usageCount": 21, "uniqueUsageCount": 2, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null }, { "value": "a2900596-5fcf-4bd6-8123-303e50df6b99", "text": null } ] }, { "evidence": "UCT1", "usageCount": 18, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "ZAP1N", "usageCount": 15, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "CISICO_1", "usageCount": 12, "uniqueUsageCount": 2, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null }, { "value": "a2900596-5fcf-4bd6-8123-303e50df6b99", "text": null } ] }, { "evidence": "CISDOKL", "usageCount": 9, "uniqueUsageCount": 2, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null }, { "value": "a2900596-5fcf-4bd6-8123-303e50df6b99", "text": null } ] }, { "evidence": "CISICO", "usageCount": 5, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "CFG_FIR", "usageCount": 2, "uniqueUsageCount": 1, "installationList": [ { "value": "a2900596-5fcf-4bd6-8123-303e50df6b99", "text": null } ] }, { "evidence": "UCT2RAD", "usageCount": 1, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "XML_FORM", "usageCount": 1, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "XML_ZAV1", "usageCount": 1, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "KH", "usageCount": 1, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "KH_1", "usageCount": 1, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "DPH_1", "usageCount": 1, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "BANHOM", "usageCount": 1, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "BANPRIK", "usageCount": 1, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "BANHOM11", "usageCount": 1, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "ZAV1_UHR", "usageCount": 1, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "BANPRI_0", "usageCount": 1, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] }, { "evidence": "UCTOSN", "usageCount": 1, "uniqueUsageCount": 1, "installationList": [ { "value": "a2900596-5fcf-4bd6-8123-303e50df6b99", "text": null } ] }, { "evidence": "CISDOK_1", "usageCount": 1, "uniqueUsageCount": 1, "installationList": [ { "value": "a2900596-5fcf-4bd6-8123-303e50df6b99", "text": null } ] }, { "evidence": "CFG_ZAK", "usageCount": 1, "uniqueUsageCount": 1, "installationList": [ { "value": "b862dd40-f3a6-4444-812e-a49b51805b1e", "text": null } ] } ] 
				axios.post("/api/documentInfoData",{  
					productName: productName,
					selectionFilter: selectionFilter,
					dateFrom: borderDates.value.startDate,
					dateTo: borderDates.value.endDate,
					dateRangeName: dateRangeName,
					tableRestrictions: tableRestrictions
				})
				.then((result) => {
					if(result.data.status == 1){
						documentInfoOverviewList.value = result.data.data.list.fullResult;
						tableData.value.result = result.data.data.list.limitedResult;
						tableData.value.totalRecords = result.data.data.list.fullResult.length;
						tableData.value.result = tableData.value.result.map(item => ({...item, product: productName}));
						//statisticsData.value = result.data.data.overview;
						tableOptions.value["filter"] = result.data.data.filterData;
					}
				})
				.catch((error) => {
					console.log("Nastala chyba: "+error);
				})
			}
			return{
				getNewData,
				selectProduct,
				selectedProductIndex,
				licenseSelected,
				organizationSelected,
				uctSelected,
				handleSelectedDateChange,
				borderDates,
				documentInfoOverviewList,
				tableData,
				tableOptions,
				tableDataRef,
				getTypeOrg,
				getTypeUct,
				getTypeLicense
			}
		}
	})
</script>

<style scoped>
	.maximum-graph-size{
		max-width: 500px;
		min-height: 417px;
		margin-left: auto;
		margin-right: auto;
	}
</style>>